import { useState } from "react";
import AppInputNew from "@/components/Core/AppInput/AppInputNew";
import Button from "@/components/Core/Button/Button";
import { useOrganisation, useUpdateOrganisation } from "@/networking/organisation.hooks";
import { SettingsLeaf } from "./SettingsLeafLayout";

const BasuppgifterPage = () => {
	const { data: organisation } = useOrganisation();
	const { mutate: updateOrganisation } = useUpdateOrganisation();

	const [orgName, setOrgName] = useState(organisation?.name || "");
	const [orgNo, setOrgNo] = useState(organisation?.orgNo || "");
	const [address1, setAddress1] = useState(organisation?.address?.address1 || "");
	const [careOf, setCareOf] = useState(organisation?.address?.careOf || "");
	const [city, setCity] = useState(organisation?.address?.city || "");
	const [postalCode, setPostalCode] = useState(organisation?.address?.postalCode || "");

	function save() {
		updateOrganisation({
			name: orgName,
			orgNo,
			address: { address1, city, careOf, postalCode },
		});
	}

	return (
		<SettingsLeaf title="Basuppgifter" description="Grunduppgifter om er organisation.">
			<AppInputNew label="Organisations-/företagsnamn" value={orgName} onChangeText={setOrgName} />
			<AppInputNew
				label="Organisationsnummer (NNNNNN-XXXX)"
				value={orgNo}
				onChangeText={setOrgNo}
			/>
			<AppInputNew label="Gatuadress" value={address1} onChangeText={setAddress1} />
			<AppInputNew label="C/O" value={careOf} onChangeText={setCareOf} />
			<div className="flex gap-3">
				<div className="w-2/5">
					<AppInputNew label="Postnummer" value={postalCode} onChangeText={setPostalCode} />
				</div>
				<div className="flex-1">
					<AppInputNew label="Stad" value={city} onChangeText={setCity} />
				</div>
			</div>
			<div>
				<Button onClick={save}>Uppdatera uppgifter</Button>
			</div>
		</SettingsLeaf>
	);
};

export default BasuppgifterPage;
